import { ApolloClient, NormalizedCacheObject } from "@apollo/client";
import { GAUGE_REWARD_QUERY, RewardData } from "../queries/gauges";

export const fetchVaultReward = async (
  client: ApolloClient<NormalizedCacheObject>,
  gaugeId: string,
  tokenAddress: string
): Promise<RewardData> => {
  const {
    data: { reward },
  } = await client.query<{ reward: RewardData }>({
    query: GAUGE_REWARD_QUERY,
    variables: {
      rewardId: `${tokenAddress.toLowerCase()}-${gaugeId.toLowerCase()}`,
    },
  });

  return reward;
};
